export default {
    center: {
        x: 0,
        y: 0,
    },
    dimensions: {
        width: 0,
        height: 0,
    },
    points: [],
};
